import './App.css';
import Sidebar from './Sidebar';
import 'bootstrap/dist/css/bootstrap.min.css';
import Incrementer from './Incrementer';
import Looper from './Looper';
import { HashRouter,BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import Create from './Create';
import BlogDetails from './BlogDetails';
import NotFound from './NotFound';
import Home from './Home';
import Main from './Main';
import PropertyList from './PropertyList';
import PropertyDetails from './PropertyDetails';
import PropertyDetailsOpen from './PropertyDetailsOpen';
import AddProperty from './AddProperty';
import PropertyListHome from './PropertyListHome';
import PropertyListApartment from './PropertyListApartment';
import PropertyListCommercial from './PropertyListCommercial';
import UserList from './UserList';
import UserDetails from './UserDetails';
import AddUser from './AddUser';
import ChatList from './ChatList';
import ChatDetails from './ChatDetails';
import Services from './Services';
import Careers from './Careers';
import AddCareer from './AddCareer';
import Banners from './Banners';
import AddBanner from './AddBanner';
import BackgroundImages from './BackgroundImages';
import AddBackgroundImage from './AddBackgroundImage';
import AddServiceType from './AddServiceType';
import ServiceList from './ServiceList';
import AddServiceItem from './AddServiceItem';
import TransactionList from './TransactionList';
import Transaction from './Transaction';
import ProtectedRoute from './ProtectedRoute';
import './i18n';

const adminOnly = [1];
const adminOrCareerManager = [1, 2];

function App() {
  return (
    
    <Router>
      <div>
        <Switch>
          <Route exact path="/">
            <Home></Home>
          </Route>
          <Route path="/main">
            <ProtectedRoute allowedRoles={adminOnly}><Main></Main></ProtectedRoute>
          </Route>
          <Route path="/create">
            <ProtectedRoute allowedRoles={adminOnly}><Create></Create></ProtectedRoute>
          </Route>
          <Route path="/user_list">
            <ProtectedRoute allowedRoles={adminOnly}><UserList></UserList></ProtectedRoute>
          </Route>
          <Route path="/chat_list">
            <ProtectedRoute allowedRoles={adminOnly}><ChatList></ChatList></ProtectedRoute>
          </Route>
          <Route path="/user_details/:id">
            <ProtectedRoute allowedRoles={adminOnly}><UserDetails></UserDetails></ProtectedRoute>
          </Route>
          <Route path="/property_list/home" exact>
            <ProtectedRoute allowedRoles={adminOnly}><PropertyListHome></PropertyListHome></ProtectedRoute>
          </Route>
          <Route path="/property_list/apartment" exact>
            <ProtectedRoute allowedRoles={adminOnly}><PropertyListApartment></PropertyListApartment></ProtectedRoute>
          </Route>
          <Route path="/property_list/commercial" exact>
            <ProtectedRoute allowedRoles={adminOnly}><PropertyListCommercial></PropertyListCommercial></ProtectedRoute>
          </Route>
          <Route path="/chat_details/:sender_id/:receiver_id">
            <ProtectedRoute allowedRoles={adminOnly}><ChatDetails></ChatDetails></ProtectedRoute>
          </Route>
          <Route path="/add_user">
            <ProtectedRoute allowedRoles={adminOnly}><AddUser></AddUser></ProtectedRoute>
          </Route>
          <Route path="/blogs/:id">
            <ProtectedRoute allowedRoles={adminOnly}><BlogDetails></BlogDetails></ProtectedRoute>
          </Route>
          <Route path="/property_list/">
            <ProtectedRoute allowedRoles={adminOnly}><PropertyList></PropertyList></ProtectedRoute>
          </Route>
          <Route path="/property/:id">
            <ProtectedRoute allowedRoles={adminOnly}><PropertyDetails></PropertyDetails></ProtectedRoute>
          </Route>
          <Route path="/propertyopen/:id">
            <ProtectedRoute allowedRoles={adminOnly}><PropertyDetailsOpen></PropertyDetailsOpen></ProtectedRoute>
          </Route>
          <Route path="/add_property">
            <ProtectedRoute allowedRoles={adminOnly}><AddProperty></AddProperty></ProtectedRoute>
          </Route>
          <Route path="/services">
            <ProtectedRoute allowedRoles={adminOnly}><Services></Services></ProtectedRoute>
          </Route>
          <Route path="/add_service_type">
            <ProtectedRoute allowedRoles={adminOnly}><AddServiceType></AddServiceType></ProtectedRoute>
          </Route>
          <Route path="/service_list/:serviceTypeId">
            <ProtectedRoute allowedRoles={adminOnly}><ServiceList></ServiceList></ProtectedRoute>
          </Route>
          <Route path="/add_service_item/:serviceTypeId">
            <ProtectedRoute allowedRoles={adminOnly}><AddServiceItem></AddServiceItem></ProtectedRoute>
          </Route>
          <Route path="/careers">
            <ProtectedRoute allowedRoles={adminOrCareerManager}><Careers></Careers></ProtectedRoute>
          </Route>
          <Route path="/add_career">
            <ProtectedRoute allowedRoles={adminOrCareerManager}><AddCareer></AddCareer></ProtectedRoute>
          </Route>
          <Route path="/banners">
            <ProtectedRoute allowedRoles={adminOnly}><Banners></Banners></ProtectedRoute>
          </Route>
          <Route path="/add_banner">
            <ProtectedRoute allowedRoles={adminOnly}><AddBanner></AddBanner></ProtectedRoute>
          </Route>
          <Route path="/background_images">
            <ProtectedRoute allowedRoles={adminOnly}><BackgroundImages></BackgroundImages></ProtectedRoute>
          </Route>
          <Route path="/add_background_image">
            <ProtectedRoute allowedRoles={adminOnly}><AddBackgroundImage></AddBackgroundImage></ProtectedRoute>
          </Route>
          <Route path="/transactions">
            <ProtectedRoute allowedRoles={adminOnly}><TransactionList></TransactionList></ProtectedRoute>
          </Route>
          <Route path="/transaction/:id">
            <ProtectedRoute allowedRoles={adminOnly}><Transaction></Transaction></ProtectedRoute>
          </Route>
          <Route path="*">
            <NotFound></NotFound>
          </Route>
        </Switch>
      </div>
    </Router>
  );
}

export default App;
